<div>
    <h1 id="successful-title" class="text">{{this.documentInfo.firstname}}, {{copyService.copies.detail_bonding_resume}}
    </h1>
    <br>
    <div class="data-info">
        <div class="subTitle-info">{{copyService.copies.solicitation_number}}</div>
        <h3 class="tel">987654</h3>
    </div>
    <br>
    <div class="data-info">
        <div class="subTitle-info">{{copyService.copies.detail_bonding_solicitation_date}}</div>
        <h3 class="tel">930 de junio de 2020 a las 10:00 a.m.</h3>
    </div>
    <br>
    <div class="data-info">
        <div class="subTitle-info">{{copyService.copies.detail_bonding_solicitation_IP}}</div>
        <h3 class="info">190.66.2.204</h3>
    </div>
    <br>
    <p class="paragraph">
        {{copyService.copies.detail_bonding_paragraph}}
    </p>
    <br>
</div>
<div class="footer">
    <div class="additionalInfoTC">
        <span id="iconCheck" class="iconPhone icon-itaufonts_telefone additionalInfoTCIconPhone">
        </span>
        <p id="additionalInfoTCtext" class="additionalInfoTCtext">
            {{ copyService.copies.successful_credit_card_creation_info_itau_phone_part_1 }}
            <strong>{{ copyService.getParametrizedCopy('successful_credit_card_creation_info_itau_phone', [maskedPhone])
                }}</strong>
            {{ copyService.copies.successful_credit_card_creation_info_itau_phone_part_2 }}
        </p>
    </div>
    <div class="container">
        <app-controls id="detailAccountCreationBtns"
            [nextLabel]="copyService.copies.successful_credit_card_creation_control_button" [nextDisabled]="false"></app-controls>
    </div>
</div>